// Slice D4 — <EngineMakeCombobox /> controlled engine-manufacturer combobox.
//
// Reused by the canvas wizard (CanvasEnginesSection) and the BoatDetail edit
// form (BoatSpecsSection) via react-hook-form Controller. No provenance
// envelope — per-engine provenance is out of scope.

import { useEngineManufacturerOptions } from '@/modules/inventory/hooks/useEngineManufacturerOptions';
import { useBrandSuggestion } from '@/modules/inventory/hooks/useBrandSuggestion';
import { BrandCombobox } from './BrandCombobox';

interface EngineMakeComboboxProps {
  value: string;
  onChange: (value: string) => void;
  id?: string;
  placeholder?: string;
}

export function EngineMakeCombobox({
  value,
  onChange,
  id,
  placeholder = 'e.g. Mercury',
}: EngineMakeComboboxProps) {
  const { data, isLoading } = useEngineManufacturerOptions();
  const suggestion = useBrandSuggestion('engine_manufacturer', value);

  return (
    <BrandCombobox
      id={id}
      value={value}
      onChange={onChange}
      options={data ?? []}
      loading={isLoading}
      placeholder={placeholder}
      suggestion={suggestion}
      onAcceptSuggestion={(name) => onChange(name)}
    />
  );
}
